import { API } from 'apis';
import { getViaAuth, responseValidator } from 'apis/api';
import { PaginationList, UserScoreLog, UserScoreLogWithUser } from 'core/domain';

// GetAllUserScoreLogs — Admin/UserScore/GetAllUserScoreLogs/{page}/{pageSize}
export const getAllUserScoreLogs = async (
    setLoading: any,
    setData: any,
    page: number,
    pageSize: number,
    query?: string,
    setAccessDenied?: any,
) => {
    setLoading(true);
    await getViaAuth<PaginationList<UserScoreLogWithUser>>(
        `${API.userScore.getAll}/${page}/${pageSize}${query || ''}`,
    ).then((response: any) => {
        setLoading(false);
        if (response.status === 401 || response.status === 403) {
            setAccessDenied && setAccessDenied(true);
            return;
        }
        if (responseValidator(response.status) && response.value) {
            setData(response.value);
        }
    });
};

// GetUserScoreLogs (per user) — Admin/User/UserLogs/{page}/{pageSize}?UserId={userId}
export const getUserScoreLogs = async (
    setLoading: any,
    setData: any,
    page: number,
    pageSize: number,
    userId: string,
    setAccessDenied?: any,
) => {
    setLoading(true);
    await getViaAuth<PaginationList<UserScoreLog>>(
        `${API.userScore.getUserLogs}/${page}/${pageSize}?UserId=${userId}`,
    ).then((response: any) => {
        setLoading(false);
        if (response.status === 401 || response.status === 403) {
            setAccessDenied && setAccessDenied(true);
            return;
        }
        if (responseValidator(response.status) && response.value) {
            setData(response.value);
        }
    });
};
